/* eslint-disable default-case */

import Axios from "axios";
import _ from "lodash";
import Result from "./result";

import { API_BASE_URL } from "./constants";
import store from "redux/store"; // Import store đã cấu hình
import { setOpenNoInternetModal } from "redux/action";

export const checkNetworkConnection = () => {
  // if ("connection" in navigator) {
  //   return navigator.connection.downlink;
  // }
  return navigator.onLine;
};

const updateOpenNoInternet = (isOpen) => {
  store.dispatch(setOpenNoInternetModal(isOpen));
};

export default class ServiceBase {
  static async requestJson(opts) {
    let axiosResult = null;
    let result = null;
    const axiosRequestConfig = {
      baseURL: opts.baseUrl || API_BASE_URL,
      timeout: opts.timeout || 30000,
      headers: {
        "Content-Type": _.get(opts, "contentType", "application/json"),
        Authorization: "Bearer ",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        ResCode: opts?.restaurantCode
          ? opts?.restaurantCode
          : localStorage.getItem("restaurantCode"),
        AppCode: "QR_ORDER",
        ...opts.headers,
      },
    };
    try {
      switch (opts.method) {
        case "GET":
          axiosResult = await Axios.get(opts.url, {
            ...axiosRequestConfig,
            params: opts.data,
          });
          break;
        case "POST":
          axiosResult = await Axios.post(
            opts.url,
            opts.data,
            axiosRequestConfig
          );
          break;
        case "PUT":
          axiosResult = await Axios.put(
            opts.url,
            opts.data,
            axiosRequestConfig
          );
          break;
        case "DELETE":
          axiosResult = await Axios.delete(opts.url, axiosRequestConfig);
          break;
        case "EXPORT":
          axiosResult = await Axios.get(`${opts.url}`, {
            ...axiosRequestConfig,
            responseType: "blob",
            params: opts.data,
          });
          break;
      }
      result = new Result(axiosResult.data, null);
    } catch (error) {
      console.log("error", error);
      const responseData = error?.response?.data;
      const normalizedValue =
        responseData && typeof responseData === "object"
          ? {
              ...responseData,
              code: String(
                responseData?.code ||
                  error?.response?.status ||
                  error?.code ||
                  ""
              ),
              message:
                responseData?.message ||
                responseData?.mess ||
                error?.message ||
                "",
              mess:
                responseData?.mess ||
                responseData?.message ||
                error?.message ||
                "",
              status: error?.response?.status,
            }
          : {
              code: String(error?.response?.status || error?.code || ""),
              message: error?.message || "",
              mess: error?.message || "",
              status: error?.response?.status,
              data: responseData,
            };

      result = new Result(normalizedValue, null);
      result.code = error?.code;
      result.message = error?.message;
      result.response = error?.response;
      return result;
    }
    return result;
  }
}
